//------------------------------------------------------------------------------
// ReportDefSaveAsModal
//------------------------------------------------------------------------------
import React, { useContext } from "react";
import AuthContext from '../../../../utils/authProvider'

import PropTypes from 'prop-types'
import { Button, Form, Input, Modal, Radio } from 'antd'

const ReportDefSaveAsModal = ({
  isReportDefSaveAsModalOpen, 
  setIsReportDefSaveAsModalOpen,
  reportDefRef,
  reportDefsRef,
  newDistrictReportName,
  setNewDistrictReportName,
  saveAsReportDef,
  width,
}) => {
  if (!reportDefRef.current) {  //Return if a reportDefRef object does not exist
    console.log('Bad or missing reportDefRef')
    return (<></>)
  }
  const [form] = Form.useForm();

  const Auth = useContext(AuthContext)
  const userId = Auth.userId
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  const isDistrictsAdmin = Auth.hasRole('DISTRICTS_ADMIN')
  const isSchoolsAdmin = Auth.hasRole('SCHOOLS_ADMIN')
  const isSchoolsGeneral = Auth.hasRole('SCHOOLS_GENERAL')

  const handleCancel = () => {
    setIsReportDefSaveAsModalOpen(false)
  }
 
  const validateReportName = () => ({
    validator(_, value) {
      const reportDefs = reportDefsRef.current
      const reportDef = reportDefRef.current
      const { reportName, isUserReport } = form.getFieldsValue(['reportName', 'isUserReport']);

      if (!reportDefs || !reportName || !isUserReport === undefined) {
        // Skip validation until data exists
        return Promise.resolve();
      }

      form.setFields([
        { name: 'reportName', errors: [] },
        { name: 'isUserReport', errors: [] },
      ]);

      let reportExists = false
      if (isUserReport === true) {
        console.log('validate user')
        reportExists = reportDefs.some(
          report =>
            report.reportName.toLowerCase() === reportName.toLowerCase() &&
            report.districtId === reportDef.districtId &&
            report.userId === userId
        ); 
      } else {
        console.log('validate district')
        reportExists = reportDefs.some(
          report =>
            report.reportName.toLowerCase() === reportName.toLowerCase() &&
            report.districtId === reportDef.districtId &&
            report.isUserReport === false
        ); 
      } 
      const errorMessage = isUserReport ? 'This user report name already exists.' : 'This district report name already exists.'
      //if (!reportExists) {clearErrors}
      return reportExists
        ? Promise.reject(new Error(errorMessage))
        : Promise.resolve();
    },
  });

  const handleOk = () => {
    form.validateFields().then((values) => {
      let updatedDefRef = {...reportDefRef.current}
      updatedDefRef.reportName = values.reportName
      updatedDefRef.isUserReport = values.isUserReport
      updatedDefRef.userId = values.isUserReport ? userId : null
      reportDefRef.current = updatedDefRef
      
      setNewDistrictReportName(values.reportName)
      saveAsReportDef(values.reportName, values.isUserReport, values.isUserReport ? userId : null)
      setIsReportDefSaveAsModalOpen(false)
    });
  };

  const newReportName = reportDefRef.current.reportName + "-Copy"
  const newIsUserReport = isSchoolsAdmin || isSchoolsGeneral ? true : false
  form.setFieldValue("reportName",newReportName)
  form.setFieldValue("isUserReport",newIsUserReport)

  return (
    <Modal
      title="Save this report definition as..."
      open={isReportDefSaveAsModalOpen}
      closable={false}
      keyboard={false}
      footer={[
        <Button key="cancel" onClick={handleCancel}>Cancel</Button>,
        <Button key="ok" type="primary" onClick={handleOk}>OK</Button>,
        
      ]}
      width={width}
      form={form}
    >
      <Form
        name='districtReportSaveAs'
        form={form}
        layout="horizontal"
      >
        <Form.Item
          name='reportName'
          label='Report Name:'
          rules={[
            { required: true, message: 'Report name is required' },
            {
              warningOnly: true,
              message: 'Report name is invalid'
            },
            { type: 'string', whitespace: true },
            validateReportName,
            ]}
        >
          <Input
            type='text'
            placeholder="Enter a name for this report"
          ></Input>
        </Form.Item>

        <Form.Item
          className='form-item-text'
          label='User or District Report'
          name='isUserReport'
          disabled={isSchoolsAdmin || isSchoolsGeneral ? true : false}
          rules={[
            validateReportName,
            ]}
        >
          <Radio.Group
            disabled={isSchoolsAdmin || isSchoolsGeneral ? true : false}
          >
            <Radio value={true}>User Report</Radio>  
            <Radio value={false}>District Report</Radio>
          </Radio.Group>
        </Form.Item>
      </Form>
    </Modal>
  )
}

// ReportDefSaveAsModal.propTypes = {
//   visible: PropTypes.bool.isRequired,
//   setVisible: PropTypes.func.isRequired
// }

export default ReportDefSaveAsModal;
